/** On android devices, when the soft keyboard pops up, it often obscures
 * the focused text field. This seems to be because it doesn't look for the
 * "nearest" scroll root to scroll up, but only supports <body>.
 * 
 * This function registers a handler that attempts to scroll
 * the focused field into view. Note: This can (and should)
 * probably be generalised, but first needs some experimentation.
 */

export default () => {
    if (typeof navigator !== 'undefined' && /Android/.test(navigator.appVersion)) {
        window.addEventListener("resize", function () {
            if (document.activeElement.tagName === "INPUT" || document.activeElement.tagName === "TEXTAREA")
                window.setTimeout(
                    () => document.activeElement.scrollIntoView(), 
                    0)
        })
    }
}

// Generalisation idea: For ANY browser, when we resize, detect if the
// focused element is no longer visible. If so, scroll into view. Debounce.



// WEBPACK FOOTER //
// ./src/client/compat/registerAndroidScrollFix.js